import React from "react";

export default function PageHeader({ title, subtitle, index, children }) {
  return (
    <div className="border-b border-zinc-200 bg-white sticky top-0 z-10">
      <div className="px-6 md:px-10 py-6 flex items-start justify-between gap-6">
        <div className="min-w-0">
          <div className="flex items-baseline gap-3">
            {index && (
              <span className="text-[10px] uppercase tracking-[0.25em] text-zinc-400 font-mono">
                /{index}
              </span>
            )}
            <h1 className="text-2xl md:text-3xl font-semibold tracking-tight text-zinc-900 truncate">
              {title}
            </h1>
          </div>
          {subtitle && <p className="mt-1 text-sm text-zinc-500">{subtitle}</p>}
        </div>
        <div className="shrink-0">{children}</div>
      </div>
    </div>
  );
}
